import { getApiOrigin } from '@klear/runtime-env'

export function resolveOrderEventPreviewFileUrl(fileUrl: string): string {
  if (fileUrl.match(/^https?:\/\//)) return fileUrl
  if (fileUrl.startsWith('/api/')) return `${getApiOrigin()}${fileUrl}`
  const baseUrl = getApiOrigin() || window.location.origin
  return fileUrl.startsWith('/') ? `${baseUrl}${fileUrl}` : `${baseUrl}/${fileUrl}`
}
